import { AllocationInterface } from "./allocation.interface";
import {
  CategoryLinkedProperties,
  ClassificationLinkedProperties,
  LinkedProperty,
  LinkedView,
} from "../../view/linked.property";
import { AllocationAsObjectType } from "@bitwarden/web-vault/app/models/store/allocations/allocation.type";

export class Allocation
  implements
    AllocationInterface,
    LinkedProperty<CategoryLinkedProperties>,
    LinkedProperty<ClassificationLinkedProperties>
{
  categoryLink: LinkedView = { id: "" }; // category ID
  classificationLink: LinkedView = { id: "" }; // classification ID
  split: number = 0; // split quantity

  toAllocationAsObjectType(): AllocationAsObjectType {
    return {
      ctId: this.categoryLink.id,
      clId: this.classificationLink.id,
      spt: this.split ?? 0,
    };
  }
}
